<!-- components/events/yuka/TopWithVideo.svelte -->
<script>
  import { t } from "../../../libs/i18n";

  const yukaVideoSrc = "https://www.youtube.com/embed/EjnUgjAf3Yo?si=67176jq2t1ppyCjv&amp;controls=0"
</script>


<!-- ======= TopWithVideo Section ======= -->
<section class="yuka-top">
  <div class="container">
    <div class="row content">
      <div class="col-lg-6 p-4 about-intro">
      <!--
        <h3 class="about-title" style="color: darkred;">{$t("yukaEvent.specialEvent")}</h3>
      -->
        <h1 class="about-title yuka-title">{$t("yukaEvent.title2AoiName")}</h1>
        <h1 class="about-title yuka-title-and">{$t("yukaEvent.title2And")}</h1>
        <h1 class="about-title yuka-title">{$t("yukaEvent.title2YukaName")}</h1>
        <h1 class="about-title">{$t("yukaEvent.title3")}</h1>
        <span class="about-discribe yuka-discribe1">{$t("yukaEvent.discribe1")}</span>
        <span class="about-discribe">{$t("yukaEvent.discribe2")}</span>
        <span class="about-discribe yuka-discribe2">{$t("yukaEvent.discribe3")}</span>
        <span class="about-discribe">{$t("yukaEvent.discribe4")}</span>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6 about-images-block">
        <div class="col-sm-12 col-md-12 col-lg-12 about-image-center">
          <div class="responsive-iframe-container">
            <iframe 
              src="{yukaVideoSrc}"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</section><!-- End TopWithVideo Section -->